import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { emitUIEvent } from '@montugroup/data-collection';
import { Divider, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { ResendInviteButton } from '../ResendInviteButton';

export const InvalidTokenPendingInvite = () => {
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();

  // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_ERROR, {
      error_code: 'invalid_token',
    });
    emitUIEvent(
      {
        component_name: 'invalid_token_pending_invite_screen',
        event_name: 'screenViewed',
        id: 'escript_onboarding_invalid_token_pending_invite',
        value: 'invalid token pending invite screen viewed',
      },
      [],
    );
  }, []);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} data-testid="customer-escript-invalid-token-pending-invite">
        Sorry we cannot fulfill the current token.
      </Typography>
      <Typography>However, you can still sign up with us with the previous sign-up link.</Typography>
      <Divider />
      <Typography variant="body2">
        Didn&apos;t get the invite? <ResendInviteButton />
      </Typography>
    </>
  );
};
